import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Modal } from 'reactstrap';

function ExceptionTraceModal(props) {
  const {
    shown, t, exception, onClose,
  } = props;

  const [modalOpen, setModalOpen] = useState(false);
  const [trace, setTrace] = useState('');

  useEffect(() => {
    setModalOpen(shown);
    if (exception) {
      const stack = exception.stack
        || exception.stacktrace
        || exception.trace
        || exception.backtrace;
      setTrace(stack || '');
    } else {
      setTrace('');
    }
  }, [exception, shown]);

  const close = () => {
    setModalOpen(false);
    if (onClose) onClose();
  };

  return (
    <Modal className="exception-trace-modal" size="lg" isOpen={modalOpen} toggle={close}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">{t('Exception Stack Trace')}</h5>
        <button
          onClick={close}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <pre className="exception-trace-modal__trace">
          {trace}
        </pre>
      </div>
    </Modal>
  );
}

ExceptionTraceModal.defaultProps = {
  shown: false,
  exception: null,
  onClose: () => {},
};

ExceptionTraceModal.propTypes = {
  t: PropTypes.any.isRequired,
  shown: PropTypes.bool,
  exception: PropTypes.object,
  onClose: PropTypes.func,
};

export default connect(() => ({}), {})(withTranslation()(ExceptionTraceModal));
